import { useEffect } from 'react';

import { useLazyQuery } from '@apollo/client';
import type { VivaExam_AssignmentType as VivaExamAssignmentType } from '__generated__/graphql-types';

import VivaExamLatestResponseQuery from 'bundles/academic-integrity/components/viva-exam/api/VivaExamLatestResponseQuery.graphql';
import type {
  VivaExamLatestResponseQueryQuery as VivaExamLatestResponseType,
  VivaExamLatestResponseQueryQueryVariables as VivaExamLatestResponseVariables,
} from 'bundles/academic-integrity/components/viva-exam/api/__generated__/VivaExamLatestResponseQuery';

export const useGetVivaExamSubmissionData = (
  assignmentId: string,
  userId: number,
  assignmentType: VivaExamAssignmentType
) => {
  const [getVivaExamLatestResponse, { data, error }] = useLazyQuery<
    VivaExamLatestResponseType,
    VivaExamLatestResponseVariables
  >(VivaExamLatestResponseQuery, {
    variables: { assignmentId, userId, assignmentType },
    context: { clientName: 'gatewayGql' },
  });

  useEffect(() => {
    getVivaExamLatestResponse();
  }, [getVivaExamLatestResponse]);

  return { vivaExamQuestions: data?.VivaExam?.queryLatestExamResponses, errorFromLatestSubmissionData: error };
};
